import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { Steps, Button, message, Icon, Tooltip } from 'antd';
import { FaGavel } from 'react-icons/fa';


// API & Contract calls
import { submitJudgeVote as submitVoteContract } from '../../contract/CustomWagersController';
import { submitJudgeVote as submitVoteApi } from '../../api-calls/customWagers';

Modal.setAppElement('#root')

@observer(["ViewStore", "CustomWagerStore", "UserStore", "web3Store", "AuthStore"])
class JudgeCustomBetModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            modalIsOpen: false,
            submittingBet: false,
            loadingMessage: "",
            modalContent: <div className="my-stats-page-title"><Icon style={{ fontSize: "68pt", color: "#3296f7" }} type='loading' /></div>
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submitJudgeVote = this.submitJudgeVote.bind(this);
        //  this.handleClickSubmit = this.handleClickSubmit.bind(this);
    }

    openModal() {
        if (this.props.wager.judge.toUpperCase() === this.props.web3Store.account.toUpperCase()) {
            if (this.props.auth) {
                this.setState({ modalIsOpen: true });
            } else {
                message.warning("You must be logged in to judge");
            }
        } else {
            message.warning("You are not the assigned judge");
        }
    }

    afterOpenModal() {
        // references are now sync'd and can be accessed.
        //this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    submitJudgeVote(winnerChoice) {
        const { UserStore } = this.props;
        let self = this;
        let wagerId = this.props.wager._id;
        let bytes32Id = this.props.wager.bytes32Id;
        let authToken = this.props.AuthStore.userAuth.auth.accessToken;
        submitVoteContract(bytes32Id, winnerChoice).then(
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! Vote not submit.");
                } else {
                    return submitVoteApi(
                        authToken,
                        wagerId,
                        bytes32Id,
                        winnerChoice,
                    ).then(function () {
                        self.setState({ modalIsOpen: false });
                        return UserStore.updateUser(authToken);
                    });
                }
            });

    }

    componentDidMount() {
        let wagerDetails = <div className="custom-bet-search-modal-results-item-grid-item">
            <h1 className="custom-bet-search-modal-title">What happened?</h1>
            <br />
            <br />
            <div>First Outcome<span ><button onClick={this.submitJudgeVote.bind(this, 1)} className="custom-btn-primary">{this.props.wager.outcomeOne}</button></span></div>
            <br />
            <div>Second Outcome<span ><button onClick={this.submitJudgeVote.bind(this, 2)} className="custom-btn-primary">{this.props.wager.outcomeTwo}</button></span></div>
            <br />
            <div>Neither<span><button onClick={this.submitJudgeVote.bind(this, 3)} className="custom-btn-primary">Refund both players</button></span></div>


        </div>;
        this.setState({ modalContent: wagerDetails });
    }



    render() {

        return (
            <div className="judge-custom-bets-modal-open-btn">
                <button className="custom-btn-primary" onClick={this.openModal}><FaGavel />  JUDGE Bet</button>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Custom Bet Modal"
                    className="custom-bet-modal"
                    overlayClassName="custom-bet-modal-overlay"
                >
                    <div className="modal-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
                    {this.state.modalContent}

                </Modal>
            </div>
        );
    }
}
export default JudgeCustomBetModal;


// WEBPACK FOOTER //
// ./src/components/modals/JudgeCustomBetModal.js